import React from 'react';
import { proofNote, stats, universities } from '../data/content';
export function ProofBar() {
  return <section className="w-full bg-blue-50 py-14 md:py-20" data-id="element-142" data-mp="ma8ap3vb8xf0">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-143" data-mp="mbt4gr9swcbt">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-144" data-mp="7kj58wg6q78x">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse" data-id="element-145" data-mp="cicdrw4yndcd">
              <dt className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-146" data-mp="3uoqqjrrhth96">
                {stat.label}
              </dt>
              <dd className="font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl" data-id="element-147" data-mp="3h4fvf6cweit">
                {stat.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 border-t border-blue-200/70 pt-8 text-center" data-id="element-148" data-mp="3psicyisy1w44">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-blue-600" data-id="element-149" data-mp="1j10rk3q2ithu">
            {proofNote}
          </p>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-3" data-id="element-150" data-mp="2seox24jntut6">
            {universities.map(university => <li key={university} className="rounded-full bg-white px-4 py-1.5 font-display text-sm font-extrabold tracking-tight text-blue-800 ring-1 ring-blue-200" data-id="element-151" data-mp="2neu7c4bmfb9p">
                {university}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}